import LoginContainer from 'modules/accountManagement/containers/LoginContainer';

const LoginView: React.FC = () => <LoginContainer />;

export default LoginView;
